<template>
    <v-container>
      <v-row>
        <v-col cols="12" sm="5">
          <v-card >
            <v-card-title><h3>上传视频</h3></v-card-title>
            <v-card-item>
              <v-progress-linear
                v-if="uploading"
                :active="uploading"
                :indeterminate="uploading"
                color="primary">                
              </v-progress-linear>
              <div v-if="uploading">正在上传</div>
              <v-file-input
                show-size
                :disabled="uploading"
                :rules="videoRules"
                accept="video/*"
                max-size="200000000"
                label="把视频拖到这里，或者点击选择视频"
                prepend-icon="mdi-camera"
                style="min-height: 400px; max-width: 400px"
                @change="uploadFile"
              ></v-file-input>
              
            </v-card-item>
          </v-card>
        </v-col>
        <v-col cols="12" sm="7" v-if="current_video!== null">
          <v-card >
            <v-card-title><h3>视频信息</h3></v-card-title>
            <v-card-item>
              <v-row class="flex-wrap">
                <v-col align-self="center" class="flex-nowrap"> 
                  
                    <video controls style="width: 100%; max-height: 500px; max-width: 500px; height: auto; width: auto;" :key="current_video.urls[0]" >
                      <source
                        :src="current_video.urls[0]"
                        type="video/mp4"
                      />
                    </video>    
                  
                    <v-btn class="ma-4" @click="selectVideo(current_video)">去剪辑</v-btn>                  
                </v-col>    
                <v-col>
                  <v-form>
                    <v-text-field
                      label="视频标题"
                      v-model="current_video.video_name"
                      >                      
                    </v-text-field>
                    <v-text-field
                      label="拍摄时间"
                      v-model="current_video.shooting_time"
                    >
                    </v-text-field>
                    <v-textarea
                      label="视频描述"
                      v-model="current_video.abstract"
                    >                    
                    </v-textarea>
                    <v-btn type="submit" block class="mt-2" @click="modity_video_info">
                      修改视频信息</v-btn>
                  </v-form>
                  
                </v-col>
              </v-row>
            </v-card-item>
          </v-card>
        </v-col>
      </v-row>

        
      <v-row>
        <v-col>
          <v-sheet class="mx-auto" >
            <v-sheet><h3 style="text-align: left;">已上传的视频列表</h3></v-sheet>
              <v-slide-group show-arrows>
                <v-slide-group-item
                v-for="video in my_uploaded_videos"
                :key="video.video_name"
                v-slot="{ isSelected, toggle }"
                >

                  <v-card
                    class="ma-2"
                    rounded
                    :color="isSelected ? 'primary' : undefined"
                    @click="toggle, handleVideoClick(isSelected,toggle,video)"
                  >
                    <v-card-item style="max-height: 300px; max-width: 200px;">
                      <v-card-title> {{ video.video_name }} </v-card-title>
                      <v-card-text> {{ video.abstract }} </v-card-text>
                      <v-card-text> {{ new Date(video.store_time).toLocaleString('zh-CN', { hour12: false }) }} </v-card-text>
                     
                    </v-card-item>
                  </v-card>
                </v-slide-group-item>
              </v-slide-group>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script setup>
    import { ref } from 'vue'
    import axios from 'axios'
    import { BASE_URL } from '@/config'
    import store from '@/store';
    import {useRouter} from 'vue-router'
    import MessageUtil from '@/utils/MessageUtil';
  

    const videoRules = ref([
      value => !!value || 'Video is required',
    ])

    const uploading = ref(false)

    const my_uploaded_videos = ref([])

    //写一个函数，获取用户上传的视频列表
    const get_user_upload_video_list = () => {
      axios.get(BASE_URL + "get_user_upload_video_list/").then(response => {
        console.log(response); // 你可以在这里处理服务器的响应
        my_uploaded_videos.value = response
      }).catch(error => {
        console.error(error); // 如果有错误，你可以在这里处理
      });
    }


    get_user_upload_video_list()

    const current_video = ref(null)

    const handleVideoClick = (isSelected,toggle, video) => {
      toggle()
      if (isSelected) {
        current_video.value = null
      } else {
        current_video.value = video
      }
      
    }

    const uploadFile = e => {
        const file = e.target.files[0]
        console.log(file)

        // 如果文件未选择，则提示用户
        if (!file) {
            return;
        }          

        // 如果文件长度大于200MB，则提示用户
        if (file.size > 5000 * 1024 * 1024) {
            alert("文件大小不能超过5GB");
            return;
        }
        let formData = new FormData();
        formData.append("file", file);

        uploading.value = true

        axios.post( BASE_URL + "upload_user_raw_video", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }).then(response => {
          console.log(response); // 你可以在这里处理服务器的响应
          MessageUtil.success("上传成功")
          uploading.value = false
          get_user_upload_video_list()
          //选择最新上传的视频
          current_video.value = my_uploaded_videos.value[0]          

        }).catch(error => {
          console.error(error); // 如果有错误，你可以在这里处理
          //提示用户，写上错误码和错误详情
          MessageUtil.handleApiError(error, '上传失败')
          uploading.value = false
        }
        );
    }

    const modity_video_info = () => {     
      axios.post(BASE_URL + "modify_uploaded_user_video_info/", {
          'transcription_id': current_video.value.transcription_id,
          'video_name': current_video.value.video_name,
          'abstract': current_video.value.abstract,
          'shooting_time': current_video.value.shooting_time
      })
      .then(response => {
        console.log(response); // 你可以在这里处理服务器的响应
        MessageUtil.success("修改成功")
      }).catch(error => {
        console.error(error); // 如果有错误，你可以在这里处理
        //提示用户，写上错误码和错误详情
        MessageUtil.handleApiError(error, '修改失败')
        const errorCode = error?.response?.status || error?.code || '未知';
        const errorDetail = error?.msg || error?.response?.data?.msg || error?.response?.data?.message || error?.message || '未知错误';
        alert("错误码：" + errorCode + "\n错误详情：" + errorDetail);
      }
      );
    }

  const router = useRouter()  

  // 点选事件，修改store中的currentVideo；告诉父组件，已经选择了视频，可以切换到下一个组件了
  const selectVideo = (video) => {     

    store.commit('setCurrentVideo', video)
    store.commit('setCurrentTextSpan', [])
    sessionStorage.setItem('currentVideo', JSON.stringify(video))
    sessionStorage.setItem('currentTextSpan', JSON.stringify([]))    
    
    router.push('kol/para')
  }

  

  </script>
  
  
